module.exports = __webpack_public_path__ + "img/emoji_104.3ad8eb16.png";